import React, { useState } from 'react'
import { Row, Col, Form, Modal, Input, Button, Select } from 'antd'
import '../../styles/manage-tickets.scss'
import { classesEventStore } from 'state/classes/classesStore'
import closeIcon from 'assets/Images/close.svg'
import TicketColors from '../TicketColors'
import { useCreateUpdateClassesStep6DropInTicket } from 'api/Classes/Step6Tickets/Tickets'
import { Step6DropInTicket } from 'types/Classes/Classes'
import ButtonSpinner from 'components/global/ButtonSpinner'

interface DropInTicketsProps {
  modalOpen: boolean
  modalClose: React.Dispatch<React.SetStateAction<boolean>>
  data?: Step6DropInTicket & { _id?: string }
}

const DropInTickets: React.FC<DropInTicketsProps> = ({
  modalOpen,
  modalClose,
  data,
}) => {
  const [form] = Form.useForm()
  const classesData = classesEventStore(store => store.classesData) as any
  const setClassesData = classesEventStore(store => store.setClassesData)
  const [ticketColor, setTicketColor] = useState<string>(
    data ? data.color : undefined,
  )
  const { mutate: dropinTicketCreate, isLoading: dropInTicketLoading } =
    useCreateUpdateClassesStep6DropInTicket()
  
  const formSchema = {
    name: data ? data.name : undefined,
    price: data ? data.price : undefined,
    priceUnit: data ? data.priceUnit : undefined,
    description: data ? data?.description : undefined,
  }

  const handleCancel = () => {
    modalClose(false)
  }

  const onFinish = (values: any) => {
    const payload: Step6DropInTicket = {
      ...values,
      color: ticketColor,
    }
    dropinTicketCreate(
      { payload, classId: classesData?._id, ticketId: data?._id },
      {
        onSuccess: result => {
          setClassesData({ ...classesData, ...result })
          modalClose(false)
        },
      },
    )
  }

  return (
    <div>
      <Modal
        open={modalOpen}
        onCancel={handleCancel}
        className="drop-in-modal"
        footer={false}
        centered
      >
        <div className="flex-center pt-20px justify-between ">
          <h2 className="w-600 text-18">Drop-in Ticket</h2>
          <img
            src={closeIcon}
            alt="close-button"
            onClick={handleCancel}
            className="close button pointer"
          />
        </div>
        <div className="mt-15px overflow-auto-y overflow-hidden-x scroller px-5px">
          <Form
            form={form}
            layout="vertical"
            initialValues={formSchema}
            onFinish={onFinish}
          >
            <Row gutter={10}>
              <Col span={24}>
                <label className="input-label required-input">
                  Ticket title
                </label>
                <Form.Item 
                  className="form-control" 
                  name="name"
                  rules={[{ required: true, message: 'Please input ticket title!' }]}
                >
                  <Input
                    placeholder="Ticket title"
                    className="form-control-field"
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={10}>
              <Col span={24}>
                <label className="input-label required-input">Price</label>
              </Col>
              <div
                className="flex align-center gap-20px w-full"
              >
                <div className="w-35p flex align-center">
                  <p className="mr-10px text-16">$</p>
                  <Form.Item 
                    name="price" 
                    className="mb-0 w-full"
                    rules={[{ required: true, message: 'Required' }]}
                  >
                    <Input
                      type="number"
                      placeholder="0"
                      className="text-end br-12 h-40px"
                    />
                  </Form.Item>
                </div>
                <div className="w-65p">
                  <Form.Item
                    className="pointer selector-input mb-0"
                    name="priceUnit"
                    rules={[{ required: true, message: 'Please select price unit!' }]}
                  >
                    <Select
                      className="select-input-field h-40px"
                      placeholder="Select"
                      optionLabelProp="label"
                      options={[
                        {
                          value: 'minute',
                          label: 'Per Minute',
                        },
                        {
                          value: 'hour',
                          label: 'Per hour',
                        },
                        {
                          value: 'day',
                          label: 'Per day',
                        },
                      ]}
                    />
                  </Form.Item>
                </div>
              </div>
            </Row>
            <Row className="mt-10px">
              <Col span={24}>
                <label htmlFor="" className="custom-field-label">
                  Description
                </label>
                <Form.Item name="description">
                  <Input.TextArea
                    className="note-field"
                    placeholder="Terms of usage of the ticket"
                    autoSize={{ minRows: 3, maxRows: 10 }}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Col span={24}>
                <label className="input-label required-input">
                  Select colors
                </label>
                <TicketColors
                  ticketColor={ticketColor}
                  setTicketColor={setTicketColor}
                />
              </Col>
            </Row>
            <Row justify="end" className="mt-20px">
              <Button
                className="stepper-button"
                disabled={dropInTicketLoading}
                htmlType="submit"
              >
                {dropInTicketLoading ? (
                  <ButtonSpinner size={20} color="#000" />
                ) : (
                  'Save'
                )}
              </Button>
            </Row>
          </Form>
        </div>
      </Modal>
    </div>
  )
}

export default DropInTickets
